import { Box } from "@chakra-ui/react";
import { colors, Spacing } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";

import {
  AlertCircleIcon,
  COST_FUNNEL_WASTE_COLOR,
  PersonIcon,
  VenueWasteOutline,
} from "../components/CostFunnelIcons";
import { FunnelCard, FunnelNoteBox, NumberedStepHeading } from "../components/CostFunnelUI";

/**
 * Step 3 - 적절한 빈소 평수 ("빈 공간 강조" 시안).
 *
 * 조문객 수보다 큰 빈소를 고르면 남는 공간만큼 비용이 낭비된다는 것을 시각화한다.
 * 디자인 탐색 과정의 다른 두 시안(3행 다이어그램, 텍스트만)은 구현 대상이 아니다.
 */
export default function Step3VenueSize() {
  return (
    <BaseStack width="100%">
      <NumberedStepHeading
        eyebrowStrong="예상 조문객 수"
        eyebrowRest="에 따라"
        index={1}
        title="적절한 빈소 평수를 확인하세요"
      />

      <Spacing gap={18} />
      <FunnelCard padding="18px 18px 20px">
        {/*
          우측 라벨 폭을 고정하고 gap 안쪽으로 화살표가 지나간다.
          화살표는 빈소 박스 SVG 안에서 박스 밖으로 그려지므로 gap 이 좁으면 라벨과 겹친다.
        */}
        <Box display="grid" gridTemplateColumns="1fr 84px" alignItems="center" gap="30px">
          <Box
            position="relative"
            width="100%"
            height="138px"
            boxSizing="border-box"
            borderRadius="12px"
            background={colors.blue100}
            border={`1.5px solid ${colors.blue400}`}
          >
            <Box position="absolute" left="10px" top="10px" display="flex" gap="6px">
              <PersonIcon />
              <PersonIcon />
              <PersonIcon />
            </Box>

            <VenueWasteOutline />

            <Box
              position="absolute"
              left={0}
              right={0}
              top="62%"
              transform="translateY(-50%)"
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap="5px"
            >
              <AlertCircleIcon />
              <Box
                as="span"
                className="subtitle_14_b"
                color={COST_FUNNEL_WASTE_COLOR.text}
                css={{ letterSpacing: 0 }}
              >
                남는 공간
              </Box>
            </Box>
          </Box>

          <Box className="subtitle_14_b" color={COST_FUNNEL_WASTE_COLOR.text} textAlign="center">
            필요 이상의
            <br />
            비용 발생
          </Box>
        </Box>

        <Spacing gap={16} />
        <Box className="body_14_r" color={colors.gray800}>
          예상 조문객 수에 맞는 빈소 평형을 선택해야 불필요한 비용을 줄일 수 있어요.
        </Box>
      </FunnelCard>

      {/*
        무빈소 안내. 원래 제출 화면에서 "0명" 을 고르면 뜨던 박스인데, 빈소를 다루는 이 화면이
        맥락이 맞아 옮겼다(제출 화면에서는 제거). 조건 없이 상시 노출이다.
      */}
      <Spacing gap={12} />
      <FunnelNoteBox label="무빈소를 고려중이라면" labelClassName="subtitle_14_b">
        빈소 이용료, 음식, 제단꽃 비용은 발생하지 않아요. 시설 이용료만 발생하므로 별도로
        확인해드릴게요.
      </FunnelNoteBox>
    </BaseStack>
  );
}
